export const set_settings = (state, settings) => (state.settings = settings);
export const set_community = (state, community) =>
  (state.community = community);
export const set_register_info = (state, info) => (state.register_info = info);
